import React from 'react';
import { motion } from 'motion/react';
import { pageVariants, sectionVariants } from '../../animations/variants';
import {
  Box,
  Typography,
  Paper,
} from '@mui/material';
import {
  Cloud as CloudIcon,
} from '@mui/icons-material';
import { getCloudTrailUser } from '../../services/cloudtrailApi';

const getDisplayNameFromEmail = (email) => {
  if (!email) return 'User';
  const localPart = email.split('@')[0];
  return localPart
    .replace(/[._-]/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

const CloudTrailDashboard = () => {
  const user = getCloudTrailUser();

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
    >
      {/* Header */}
      <motion.div variants={sectionVariants}>
      <Box sx={{ mb: { xs: 3, sm: 4 } }}>
        <Typography
          variant="h4"
          sx={{
            fontFamily: 'Bitter, Georgia, serif',
            fontWeight: 600,
            color: '#253E66',
            mb: 1,
            fontSize: { xs: '1.5rem', sm: '2.125rem' },
          }}
        >
          Welcome{user?.email ? `, ${getDisplayNameFromEmail(user.email)}` : ''}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: '#666666',
            fontFamily: 'Metropolis, sans-serif',
          }}
        >
          Manage AWS CloudTrail centrally across all accounts in your organization
        </Typography>
      </Box>
      </motion.div>

      {/* Placeholder */}
      <motion.div variants={sectionVariants}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 4, sm: 6 },
          border: '1px solid #E5E5E5',
          borderRadius: '8px',
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            backgroundColor: 'rgba(70, 152, 211, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto',
            mb: 3,
          }}
        >
          <CloudIcon sx={{ fontSize: 40, color: '#4698D3' }} />
        </Box>

        <Typography
          variant="h5"
          sx={{
            fontFamily: 'Metropolis, sans-serif',
            fontWeight: 600,
            color: '#253E66',
            mb: 1.5,
          }}
        >
          CloudTrail
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: '#666666',
            fontFamily: 'Metropolis, sans-serif',
            maxWidth: 480,
            margin: '0 auto',
            lineHeight: 1.6,
          }}
        >
          CloudTrail management features are coming soon. You'll be able to view and manage
          AWS CloudTrail configurations across all accounts in your organization from this portal.
        </Typography>
      </Paper>
      </motion.div>
    </motion.div>
  );
};

export default CloudTrailDashboard;
